"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _LazyValueStore = require("../store/LazyValueStore");

var _DealPipelineAPI = require("./api/DealPipelineAPI");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: _DealPipelineAPI.fetch,
  namespace: _ActionNamespaces.DEAL_PIPELINES
}).defineName('DealPipelineStore').defineResponseTo(_ActionTypes.PIPELINE_UPDATED, function (state, _ref) {
  var key = _ref.key,
      value = _ref.value;
  return state.setIn(['value', key], value);
}).defineResponseTo(_ActionTypes.PIPELINE_DELETED, function (state, pipelineId) {
  return state.deleteIn(['value', pipelineId]);
}).defineResponseTo(_ActionTypes.PIPELINES_UPDATED, function (state, pipelines) {
  var updatedPipelines = pipelines.reduce(function (map, pipeline) {
    return map.set(pipeline.get('pipelineId'), pipeline);
  }, (0, _immutable.OrderedMap)());
  return state.set('value', updatedPipelines);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;